import { Cancel, Modify, Place } from './components';

const OrderFlow = {
  Place,
  Cancel,
  Modify,
};

export { OrderFlow };
